export default __webpack_public_path__ + "static/media/support.d8884f38.svg";